import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '~/App';
import { useLocalStorage } from '~/hooks';
import { useBreakpoint } from '~/hooks/useBreakpoint';

// ? commented out because browser router does not have access to context for abilities
// export function loader({ params }: LoaderFunctionArgs) {
//   // ! browser only
//   const isMobile = window.innerWidth < 1024;

//   return params.view === undefined
//     ? redirect(isMobile ? '/jobs/scheduled' : '/jobs/scheduled')
//     : null;
// }

export default function JobsIndexRoute() {
  const navigate = useNavigate();
  const { ability } = useAppContext();
  const { isMobile } = useBreakpoint();
  const localStorage = useLocalStorage();
  const { hash } = useLocation();

  // If there's a hash with settings info (e.g., #org-settings-open:referrals from deep link),
  // use the default navigateTo but preserve the hash instead of using stored last view
  const hasSettingsHash =
    hash.includes('org-settings-open') || hash.includes('settings');
  const navigateTo = localStorage.get('nav.jobs') ?? '/jobs/scheduled';

  useEffect(() => {
    // NOTE: feat.schedule_view permission check removed - calendar/planner access granted to all tenants while pricing is being finalized
    const defaultView =
      !isMobile && ability.can('use', 'feat.jobs.default-to-calendar')
        ? '/jobs/calendar'
        : '/jobs/scheduled';

    // If there's a settings hash, use default view (not last viewed) to avoid navigation conflicts
    const targetPath = hasSettingsHash ? defaultView : navigateTo;

    navigate(targetPath + hash);
  }, []);

  return null;
}
